import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_gallery,
  add_gallery,
  update_gallery,
  delete_gallery,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";
const getTodayDate = () => {
    const today = new Date();
    const offset = today.getTimezoneOffset();
    today.setMinutes(today.getMinutes() - offset);
    return today.toISOString().split("T")[0];
  };
const initialState = {
  gallerys: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
category:"" ,   
description:"" ,   
image:""    
  },
};

// Async Thunks for API Calls
export const fetchgallery = createAsyncThunk(
  "gallery/fetchgallery",
  async (
    { page, page_size,type, school_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_gallery(
        page,
        page_size,
        type,
        school_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const creategallery = createAsyncThunk(
  "gallery/creategallery",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_gallery(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updategallery = createAsyncThunk(
  "gallery/updategallery",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_gallery(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletegallery = createAsyncThunk(
  "gallery/deletegallery",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_gallery({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const gallerySlice = createSlice({
  name: "gallerys",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
        const { name, value } = action.payload;
        state.filterData[name] = value;
      },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const {
        id,
        category ,   
description ,   
image
      } = action.payload;
      state.formData = {
        id,
        category ,   
        description ,   
        image
      };
    },
    resetFormData(state) {
      state.formData = {
        category:"" ,   
        description:"" ,   
        image:""
      };
    },
    setgallery(state, action) {
      state.gallerys = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
   
      .addCase(fetchgallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchgallery.fulfilled, (state, action) => {
        state.loading = false;
        state.gallerys = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchgallery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.gallerys = [];

      })

      // Add Class
      .addCase(creategallery.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(creategallery.fulfilled, (state, action) => {
        state.addLoading = false;
        state.gallerys = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(creategallery.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updategallery.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updategallery.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updategallery.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;
        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletegallery.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletegallery.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletegallery.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setgallery,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  updateFilterData,

} = gallerySlice.actions;
export default gallerySlice.reducer;
